// check first error
export const firstError = (errors: { [key: string]: string[] }): string | null => {
  for (const source of Object.values(errors)) {
    if (source.length > 0) {
      return source[0]
    }
  }
  return null
}
